import React, { useEffect, useState } from "react";
import api from '../../services/api';
import Modal from 'react-modal';
import Swal from "sweetalert2";
import Flex from '@react-css/flex';
import DatePicker  from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { DynamicSelect } from "../../components/DynamicSelect";
import { DynamicTextareaOnChange } from "../../components/DynamicTextarea";
import { StyledForm } from "../../styled-components/StyledForm.style";

export const ModalVisibilidadeTarefas = ({
    idProcesso,
    laudo,
    peritos,
    isOpen,
    setIsOpen,
    aoSalvar
}) => {
    const [isLoading, setisLoading] = useState(false);
    const [loadEtapa, setLoadEtapa] = useState([]);
    const [isPerito, setIsPerito] = useState(false);
    const [isDataFatal, setIsDataFatal] = useState(false);
    const [observacao, setObservacao] = useState("");
    const [dataFatal, setDataFatal] = useState(null);

    var [perito, setPerito] = useState(null);
    var [idPerito, setIdPerito] = useState(null);
    const [peritoList, setPeritoList] = useState([]);

    var [etapa, setEtapa] = useState(null);
    var [idEtapa, setIdEtapa] = useState(null);
    const [etapaList, setEtapaList] = useState([]);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const onAfterOpen = () => { };
    const closeModal = () => {
        setEtapa(null);
        setIdEtapa(null);
        setLoadEtapa([]);
        setIsPerito(false);
        setDataFatal(null);
        setIsDataFatal(false);
        setObservacao("");
        setisLoading(false);
        setIsOpen(false);
     }

    const getPeritos = (currentValue, value) => {
        if (!value) {
            setPerito(null);
            setIdPerito(null);
            return;
        }

        var peritoResult = peritoList.filter(function (o) {
            return o.idUsuario == value;
        });

        perito = peritoResult[0].nome;
        idPerito = peritoResult[0].idUsuario;
        setPerito(perito);
        setIdPerito(idPerito);
    };

    const getEtapas = async (currentValue, value) => {
        if (!value) {
            setEtapa(null);
            setIdEtapa(null);
            setIdPerito(null);
            setLoadEtapa([]);
            setDataFatal(null);
            setIsDataFatal(false);
            setIsPerito(false);
            return;
        }

        const itemSelecionado = etapaList.find(o => o.idEtapa == value);
        
        if (itemSelecionado) {
            setisLoading(true);
            setIsPerito(false);
            setEtapa(itemSelecionado.nomeEtapa);
            setIdEtapa(itemSelecionado.idEtapa);
            try {
                const headers = { 'Content-Type': 'application/json' };
                const response = await api.get(`Visibilidade/etapa/load/sla/${itemSelecionado.idEtapa}`, {
                    params: {
                        idProcesso: laudo.idProcesso,
                        idTipoServico: laudo.idTipoServico
                    },
                    headers: headers
                });
                const dadosRetorno = response.data.data;
                if (dadosRetorno.alterarPrazo) {
                    setIsDataFatal(true);
                } else {
                    setIsDataFatal(false);
                }
                setIsPerito(true);
                setLoadEtapa(dadosRetorno);
                setisLoading(false);
            } catch (error) {
                console.error("Erro ao buscar dados do endpoint secundário:", error);
            }
        }
    };

    const getLoadEtapa = async (idJornada) => {
        setisLoading(true);
        let list = null;
        try {
            const response = await api.get(`Visibilidade/etapa/load/${idJornada}`);
            list = response.data.data;
            setEtapaList(list);
        } catch (err) {
            console.error(err);
        } finally {
            setisLoading(false);
            return list;
        }
    };

    const campoObrigatorio = (campo) => {
            Swal.fire({
                title: "Atenção",
                html: `${campo}`,
                icon: "warning",
                confirmButtonText: "OK",
            });
        };

    const onIncluirTarefa = () => {
        if (!etapa) { campoObrigatorio("Você precisa escolher uma Etapa"); return false; }
        if (isDataFatal && !dataFatal) { campoObrigatorio("Você precisa de uma Data Fatal"); return false; }
        if (!perito) { campoObrigatorio("Você precisa escolher uma Perito"); return false; }

        Swal.fire({
            html: `Deseja Incluir a Tarefa para Laudo <strong>${laudo.processoSigla}</strong>?`,
            icon: "info",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            setisLoading(true);
            if (result.isConfirmed) {
                Swal.showLoading();
                try {
                    const headers = {
                        'Content-Type': 'application/json'
                    };
                    const dados = {
                        idProcesso: laudo.idProcesso,
                        idTipoServico: laudo.idTipoServico,
                        idResponsavel: idPerito,
                        idEtapa: idEtapa,
                        dataFatal: dataFatal,
                        observacao: observacao,
                    };
                    await api.post(`Visibilidade/tarefa/executa/incluir`, dados, { headers });
                    setisLoading(false);
                    
                    Swal.fire({
                        title: "Sucesso",
                        text: "Tarefa Inserida com Sucesso!",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    }).then(() => {
                        setEtapa(null);
                        setIdEtapa(null);
                        setLoadEtapa([]);
                        setIsPerito(false);
                        setDataFatal(null);
                        setIsDataFatal(false);
                        setObservacao("");

                        setisLoading(false);
                        setIsOpen(false);
                        closeModal();

                        if (aoSalvar) {
                            aoSalvar(laudo.idProcesso, laudo.idTipoServico);
                        }
                    });

                } catch (err) {setisLoading(false);}
            } else {
                setisLoading(false);
            }
        });
    };

    useEffect(() => {
        if(isOpen) {
            setPeritoList(peritos);
            if (laudo && laudo.idJornada) {
                getLoadEtapa(laudo.idJornada);
            }
        }
    }, [isOpen])

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Incluir Tarefa"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="28" height="28" className="me-2">
                                        <path fill={'#999'} d="M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l180 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3l0-38.1c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L96 0zM357.5 176L264 176c-13.3 0-24-10.7-24-24L240 58.5 357.5 176zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"/></svg>
                                    Incluir nova Tarefa</p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                { isLoading ? (
                    <div className="text-center">
                        <div className="text-items-center">
                            <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                            <div className="mt-2">
                                <strong style={{ color: "#EE4B21" }}>Aguarde enquanto validamos as informações</strong>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="row mb-2" style={{ fontSize: "14px" }}>
                            <div className="col-4 text-center"><span style={{ color: "#999" }}>Processo</span><br/>{ laudo?.processoSigla || "-" }</div>
                            <div className="col-4 text-center"><span style={{ color: "#999" }}>Líder</span><br/>{ laudo?.liderProcesso || "-" }</div>
                            <div className="col-4 text-center"><span style={{ color: "#999" }}>Cliente</span><br/>{ laudo?.cliente || "-" }</div>                            
                        </div>
                        <div className="row" style={{ fontSize: "14px" }}>
                            <div className="col-4 text-center"><span style={{ color: "#999" }}>Disciplina</span><br/>{ laudo?.disciplina }</div>
                            <div className="col-8 text-center"><span style={{ color: "#999" }}>Segurado</span><br/>{ laudo?.segurado || "-" }</div>
                        </div>
                        
                        <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                        <div className="row align-items-center justify-content-center mt-3">
                            <div className="col-12 text-center mb-2">
                                <DynamicSelect placeholder={''} valuetext={etapa} label={'Etapa'} name={'idEtapa'} options={[...etapaList].sort((a, b) => a.nomeEtapa.localeCompare(b.nomeEtapa))} keyValue={'idEtapa'} keyLabel={'nomeEtapa'} clearOption={true} paramMethod={getEtapas} />
                            </div>
                        </div>

                        { isPerito && (
                            <>
                                <div className="row align-items-center justify-content-left mt-3">
                                    <div className="col-3 text-center mb-2">
                                        <span style={{ color: "#999", fontSize: "14px" }}>Estimativa</span><br />
                                        {loadEtapa?.estimativa} {loadEtapa?.unidadeSla}
                                    </div>
                                    <div className="col-3 text-center mb-2">
                                        <span style={{ color: "#999", fontSize: "14px" }}>Data Prazo</span><br />
                                        { loadEtapa?.dataPrazo ? new Date(loadEtapa.dataPrazo).toLocaleDateString('pt-BR') : "-" }
                                    </div>
                                    
                                    <div className="col-6 text-center mb-2">
                                        {/* Renderiza DatePicker apenas se alterarPrazo for true */}
                                        { loadEtapa?.alterarPrazo && (
                                            <>
                                                <span style={{ color: "#999", fontSize: "14px" }}>Data Fatal</span><br />
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    locale="pt-BR"
                                                    className="input-form text-center"
                                                    placeholderText=""
                                                    selected={dataFatal}
                                                    onChange={(date) => setDataFatal(date)}
                                                />
                                            </>
                                        )}
                                    </div>
                                </div>
                                
                                <div className="row align-items-center justify-content-center mt-3">
                                    <div className="col-12 text-center mb-2">
                                        <DynamicSelect placeholder={''} valuetext={perito} label={'Profissionais'} name={'idPerito'} options={[...peritoList].sort((a, b) => a.nome.localeCompare(b.nome))} keyValue={'idUsuario'} keyLabel={'nome'} clearOption={true} paramMethod={getPeritos} />
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                        <div className="row align-items-center justify-content-center">
                            <div className="col text-center">
                                <DynamicTextareaOnChange 
                                    placeholder={"Observações"} 
                                    label={"Observações"} 
                                    name={"observacao"}
                                    valuetext={observacao}
                                    onChange={(e) => setObservacao(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                        <Flex>
                            <Flex.Item>
                                <div className="row align-items-center justify-content-center">
                                    <div className="col text-center">
                                        <input 
                                            className='default-button-red' 
                                            value={'Incluir'} 
                                            type="button" 
                                            onClick={onIncluirTarefa.bind()}
                                        />
                                    </div>
                                </div>
                            </Flex.Item>
                        </Flex>
                    </>
                )}
            </StyledForm>
        </Modal>
    );
};